var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3,
    fill: "#9D9D9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2466 19.6663H6.99663C6.68413 19.6663 6.45913 19.5136 6.32163 19.208C6.18413 18.9025 6.20913 18.6108 6.39663 18.333L9.99663 12.9997L6.39663 7.66634C6.20913 7.38856 6.18413 7.0969 6.32163 6.79134C6.45913 6.48579 6.68413 6.33301 6.99663 6.33301H15.2466C15.4841 6.33301 15.7091 6.3919 15.9216 6.50967C16.1341 6.62745 16.3091 6.79079 16.4466 6.99967L19.8216 11.9997C20.0216 12.2913 20.1216 12.6247 20.1216 12.9997C20.1216 13.3747 20.0216 13.708 19.8216 13.9997L16.4466 18.9997C16.3091 19.208 16.1341 19.3713 15.9216 19.4897C15.7091 19.608 15.4841 19.6669 15.2466 19.6663ZM8.49663 17.9997H15.2466L18.6216 12.9997L15.2466 7.99967H8.49663L11.1966 11.9997C11.3966 12.2913 11.4966 12.6247 11.4966 12.9997C11.4966 13.3747 11.3966 13.708 11.1966 13.9997L8.49663 17.9997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7L15 13L11.5 18.5",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraIcon);
export default __webpack_public_path__ + "static/media/Extra_Icon.2c125680bd7bbb75e413a41d18ec9461.svg";
export { ForwardRef as ReactComponent };